import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Switch } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import DispalyImage from 'components/wrapperComponents/DispalyImage';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { AnnouncementModel } from 'model/screensModels/AnnouncementModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import { useEffect, useMemo, useState } from 'react';
import { AnnouncementService } from 'services/menu/announcementService/AnnouncementService';
import { conformationAlert } from 'services/shared/alert';



export const AnnouncementList = ({ setFlag, updateRecord, loadRecentAnnouncement }) => {

  const [announcementList, setAnnouncementList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })

  const columns = useMemo(() =>
    [
      {
        header: 'Attachment',
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            < DispalyImage
                  imageUrl={row.original?.attachment}
                  imageSize={msgTypes.IMAGE_SIZE.SMALL} />
          </Box>
        ),
        size: 50
      },
      {
        accessorKey: "title",
        header: "Title",
        size: 150
      },
      {
        accessorKey: "message",
        header: "Message",
        size: 200
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 50,
        Cell: ({ cell, row }) => (
          <Switch
            name="status"
            checked={row?.original?.status}
            onChange={() => {updateStatus(row.original)}}
          />
        ),
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
            <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
            </Tooltip>
          </div>
        ),
        size: 10,
        grow: false,
      },

    ], []);


  useEffect(() => {
    getAnnouncementList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])


  const updateStatus = async (record: AnnouncementModel) => {
    record.status = !record.status;
    const updateStatusFlag = await conformationAlert(
      msgTypes.CONFORMATION_MESSAGE.UPDATE_RECORD,
      msgTypes.CONFORMATION_ICON.WARNING,
      "Yes! Update"
    );
    if (updateStatusFlag) {
      const res = await AnnouncementService.saveAnnouncement(record)
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getAnnouncementList();
      }
    }
  };


  const prepareRequest = async () => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;

    return requestBody;
  }

  //Get Announcement list
  const getAnnouncementList = async () => {
    const requestBody = await prepareRequest();
    const res = await AnnouncementService.getAnnouncementList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setAnnouncementList(res)
    }
  }



  const editRecord = (record: AnnouncementModel) => {
    updateRecord(record);
    setFlag(true)
  }

  const deleteRecord = async (record: AnnouncementModel) => {
    const requestData: AnnouncementModel = new AnnouncementModel();
    requestData.announcementId = record.announcementId
    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");
    if (deleteFlag) {
      const res = await AnnouncementService.deleteAnnouncement(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getAnnouncementList();
        loadRecentAnnouncement();
      }
    }
  }

  const initialValues = {}
  const onSubmit = () => {
    getAnnouncementList();
  }


  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {
        formik =>
        (
          <Form>
               {announcementList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control='materialTable'
                  tableColumn={columns}
                  tableData={announcementList}
                  setPagination={setPagination}
                />
              }
            />
          ) : null}
          </Form>
        )
      }
    </Formik>
  )
}
